
/*
 * Caution! Don't write parameters that need to be HIDDEN in the environment variables.
 *     API_KEY
 *     ACCESS_KEY
 *     SECRET_KEY
 *     ...etc
 * 
 * Execution example to change the stage.
 *     REACT_APP_STAGE=staging npm run start
 *     REACT_APP_STAGE=staging npm run build
 * 
 */ 

const stage = process.env.REACT_APP_STAGE || 'local';

if (stage === 'master') {
  const empty = () => undefined;

  console.debug = empty;
  console.info = empty;
  console.log = empty;
  console.warn = empty;
  console.error = empty;
}

const envVars = {
  local: {
    ENV: 'local',
    IS_ANALYTICS: false,
    RJS_OPEN_API_ENDPOINT: 'https://api-stg.r-staffing.co.jp',
    OD_SERVICE_API_ENDPOINT: 'https://www-dev.jobma.r-staffing.co.jp/jobma/api/od-service',
  },
  develop: {
    ENV: 'dev',
    IS_ANALYTICS: false,
    RJS_OPEN_API_ENDPOINT: 'https://api-stg.r-staffing.co.jp',
    OD_SERVICE_API_ENDPOINT: 'https://www-dev.jobma.r-staffing.co.jp/jobma/api/od-service',
  },
  staging: {
    ENV: 'stg',
    IS_ANALYTICS: true,
    RJS_OPEN_API_ENDPOINT: 'https://api-stg.r-staffing.co.jp',
    OD_SERVICE_API_ENDPOINT: 'https://www-stg.r-staffing.co.jp/jobma/api/od-service',
  },
  master: {
    ENV: 'prd',
    IS_ANALYTICS: true,
    RJS_OPEN_API_ENDPOINT: 'https://api.r-staffing.co.jp',
    OD_SERVICE_API_ENDPOINT: 'https://www.r-staffing.co.jp/jobma/api/od-service',
  },
};  

const env = envVars[stage];

export default env;